export default __webpack_public_path__ + "static/media/Guitar-Backgrounds-Images-HD-750x490.d2a79151.jpeg";